/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * CSS variables IE fix
 */

import cssVars from 'css-vars-ponyfill';

/**
 * Resize iframes in rich text fields
 */

function resizeIframes(resizeElements) {
    if (resizeElements.length > 0) {
        for (var i = 0; i < resizeElements.length; i++) {
            resizeElements[i].setAttribute("style", `height: ${resizeElements[i].clientWidth * 0.5625}px`);
        }
    }
}

/**
 * Object fit IE fix
 */

var objectFitImages = require('object-fit-images');

objectFitImages();

window.Vue = require('vue');
Vue.prototype.svg = require('./svg');

// import our plugin
import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } })

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import route from 'ziggy'
import { Ziggy } from '@/ziggy'

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
    position: 'bottom-center',
    fullWidth: true,
    className: 'toasted-custom'
})

import vueVimeoPlayer from 'vue-vimeo-player'
Vue.use(vueVimeoPlayer)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueCollapse from 'vue2-collapse';
Vue.use(VueCollapse);

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    }
});

import store from '@/store'
import router from '@/router'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

export const bus = new Vue();

const app = new Vue({
    store,
    router,
    el: '#app',
    data: {
        isMobile: false,
        navigationIsVisble: false,
        stickyNavigation: false,
        mobileSearchIsVisible: false,
        resizingTimeout: null,
        slideoutIsOpen: false
    },

    created() {
        window.addEventListener('resize', () => {
            this.init()
        })

        window.addEventListener('orientationchange', () => {
            this.init()
        })
    },

    mounted() {
        cssVars();

        const iframes = document.querySelectorAll('.rich-text iframe');
        if (iframes) {
            window.addEventListener('resize', () => {
                resizeIframes(iframes);
            })
            window.addEventListener('orientationchange', () => {
                resizeIframes(iframes);
            })
            resizeIframes(iframes);
        }

        this.init()
        const self = this;

        let last_known_scroll_position = 0;
        let ticking = false;
        window.addEventListener('scroll', function (e) {
            last_known_scroll_position = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function () {
                    if (last_known_scroll_position > 0) {
                        self.stickyNavigation = true;
                    } else {
                        self.stickyNavigation = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });

        this.$nextTick().then(() => {
            let list_total = localStorage.getItem(`ttpe-list-total`) || 0;
            const heart = document.querySelector('.icon-heart')
            if (heart) {
                heart.setAttribute('data-count', parseInt(list_total) !== 0 ? list_total : '')
            }
        })

        document.onkeydown = function (evt) {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                self.navigationIsVisble = false;
                self.mobileSearchIsVisible = false;
            }
        };
    },

    methods: {
        init() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            this.isMobile = window.innerWidth < 1279.98;
        },
    },

    watch: {
        navigationIsVisble: function () {
            document.getElementsByTagName('body')[0].classList.toggle("navigation-active");
        },
        mobileSearchIsVisible: function () {
            document.getElementsByTagName('body')[0].classList.toggle("mobile-search-active");
        },
        stickyNavigation: function () {
            document.getElementsByTagName('header')[0].classList.toggle("fixed");
        },
        slideoutIsOpen: function () {
            document.getElementsByTagName('body')[0].classList.toggle("slideout-active");
        },
    }
});
